// extracted by mini-css-extract-plugin
export default {"container":"styles_container__XEX9V","error":"styles_error__G21gJ","fullView":"styles_fullView__9cq0x","shimmer":"styles_shimmer__kB6Aa"};